import React from "react";
import { LuiFormikForm, LuiFormSubmitButton } from "@linzjs/lui";
import { MultiCheckbox, RadioGroup, RadioButton, TextInput } from "./Forms"
import { withRouter } from "react-router";

class Search extends React.Component {

  static allOffices = [
    {"lable": "Auckland", "value": "Auckland"},
    {"lable": "Hamilton (incl New Plymouth)", "value": "Hamilton,New Plymouth"},
    {"lable": "Wellington (incl Napier & Gisborne)", "value": "Wellington,Napier,Gisborne"},
    {"lable": "Christchurch (incl Nelson, Blenheim & Hokitika)", "value": "Christchurch,Nelson,Blenheim,Hokitika"},
    {"lable": "Dunedin (incl Invercargill)", "value": "Dunedin,Invercargill"},
    {"lable": "National Office", "value": "National Office"}
  ];

  static allAgencies = [
    { "lable": "LINZ", "value": "LINZ" },
    { "lable": "Education", "value": "Education" },
    { "lable": "Ministry of Works", "value": "MOW" },
    { "lable": "Railways", "value": "Railways" },
    { "lable": "Lands", "value": "Lands" },
    { "lable": "Lands and Survey", "value": "Survey" },
    { "lable": "DOSLI", "value": "DOSLI" },
    { "lable": "Miscellaneous", "value": "Mixed" },
  ];

  constructor(props) {
    super(props);
    Search.allOffices.map(office => office["isChecked"] = false);
    Search.allAgencies.map(agency => agency["isChecked"] = false);
    this.state = {
      FileNumber: "",
      Title: "",
      partial: "on",
      offices: Search.allOffices,
      agencies: Search.allAgencies
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    if (target.type === "checkbox") {
      const {offices, agencies} = this.state;
      for (let i = 0; i < offices.length; i++) {
        const office = offices[i];
        if (office.value === target.value) {
          office["isChecked"] =  target.checked;
          break;
        }
      }
      for (let i = 0; i < agencies.length; i++) {
        const agency = agencies[i];
        if (agency.value === target.value) {
          agency["isChecked"] =  target.checked;
          break;
        }
      }
      this.setState({offices: offices, agencies: agencies});
    } else {
      this.setState({
        [target.name]: target.value
      });
    }
  }
  
  handleSubmit() {
    const {offices, agencies, FileNumber, Title, partial} = this.state;
    let checkedOffices = [];
    offices.forEach(office => {
      if (office["isChecked"]) {
        checkedOffices = checkedOffices.concat(office.value);
      }
    })
    let checkedAgencies = [];
    agencies.forEach(agency => {
      if (agency["isChecked"]) {
        checkedAgencies = checkedAgencies.concat(agency.value);
      }
    })
    this.props.history.push({
      pathname: "/results",
      state: {
        "offices": checkedOffices,
        "agencies": checkedAgencies,
        "FileNumber": FileNumber,
        "Title": Title,
        "partial": partial
      }
    });
  }

  render() {
    return (
      <>
        <div className="g-flex-row">
          <div className="lui-text-content-area">
            <p>You are able to search the database using a number of criteria including file
              number, title, and sometimes legal description. Once identified in the database,
              the files can be requested for viewing.</p>
            <p><strong>Warning:</strong> The ELFI database is no longer maintained, as the
              LINZ file system has been migrated to an Objective database which is currently
              not accessible from the internet.  This search application will only locate
              information existing before August 2005.</p>
            <p>
              <strong>Search tip:</strong>
              <br />
              Not all volumes for predecessor agencies are recorded in ELFI - often only
              the first volume will show up, with the number of volumes available recorded
              &nbsp; in the notes field.&nbsp; If you require further information on volumes not
              shown, please contact the office responsible for the file (owner location).
            </p>
            <div className="lui-text-content-area">
              <LuiFormikForm
                initialValues={{}}
                onSubmit={this.handleSubmit.bind(this)}>
                <fieldset>
                  <div className="g-flex-row">
                    <div className="g-flex-col-sm-7 g-flex-col-lg-6">
                      <div className="lui-text-content-area">
                        <h3>Regions/Offices</h3>
                        {
                          Search.allOffices.map((item, index) => <MultiCheckbox key={item.value} name={item.value} label={item.lable} value={item.value} checked={this.state["office." + index]} onChange={this.handleInputChange} />)
                        }
                      </div>
                    </div>
                    <div className="g-flex-col-xs-12 g-flex-col-sm-5 g-flex-col-lg-6">
                      <div className="lui-text-content-area">
                        <h3>Agency</h3>
                        {
                          Search.allAgencies.map((item, index) => <MultiCheckbox key={item.value} name={item.value} label={item.lable} value={item.value} checked={this.state["agency." + index]} onChange={this.handleInputChange} />)
                        }
                      </div>
                    </div>
                  </div>
                  <div className="lui-text-content-area">
                    <TextInput name="FileNumber" label="File Number" value={this.state.FileNumber} onChange={this.handleInputChange} />
                    <TextInput name="Title" label="Keywords" value={this.state.Title} onChange={this.handleInputChange} />
                    <RadioGroup legend="Search By" name="partial">
                      <RadioButton label="Keywords" value="off" name="partial" checked={this.state["partial"] === "off"} onChange={this.handleInputChange} />
                      <RadioButton label="Partial words" value="on" name="partial" checked={this.state["partial"] === "on"} onChange={this.handleInputChange} />
                    </RadioGroup>
                  </div>
                  <div className="lui-text-content-area">
                    <p>
                      <LuiFormSubmitButton>Search</LuiFormSubmitButton>
                    </p>
                  </div>
                </fieldset>
              </LuiFormikForm>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Search);
